export default __webpack_public_path__ + "static/media/new-ai-logo.54c78b92.svg";